export enum FileExtensionIconType {
  PDF = "PDF",
  JPEG = "FileImage",
  JPG = "FileImage",
  PNG = "FileImage",
  TIFF = "FileImage"
}
